<template>
    <jet-authentication-card>
        <template #logo>
            <jet-authentication-card-logo />
        </template>

        <jet-validation-errors class="mb-4" />

        <div v-if="status" class="mb-4 font-medium text-sm text-green-600">
            {{ status }}
        </div>
        <div v-if="step == 1">
            <email-step :form="form" @next="handleNextStep" @isMultipleTenants="isMultipleTenantshandle" />

        </div>

        <div v-if="step == 2">
            <password-step :form="form" :email="form.email" @next="handleNextStep" :tenants="tenants"
            :selectedTenant="selectedTenant" />
        </div>


        <div v-if="step == 3">
            <select-tenant :form="form" :isMultipleTenants="isMultipleTenants" :tenants="tenants"
                :selectedTenant="selectedTenant" @next="handleNextStep" />
        </div>


    </jet-authentication-card>
</template>

<script>
import JetAuthenticationCard from '@/Jetstream/AuthenticationCard'
import JetAuthenticationCardLogo from '@/Jetstream/AuthenticationCardLogo'
import JetButton from '@/Jetstream/Button'
import JetInput from '@/Jetstream/Input'
import JetCheckbox from '@/Jetstream/Checkbox'
import JetLabel from '@/Jetstream/Label'
import JetValidationErrors from '@/Jetstream/ValidationErrors'
import EmailStep from "@/Pages/Auth/UniversalLogin/EmailStep";
import PasswordStep from "@/Pages/Auth/UniversalLogin/PasswordStep";
import SelectTenant from "@/Pages/Auth/UniversalLogin/SelectTenant";



export default {
    components: {
        JetAuthenticationCard,
        JetAuthenticationCardLogo,
        JetButton,
        JetInput,
        JetCheckbox,
        JetLabel,
        JetValidationErrors,
        EmailStep,
        PasswordStep,
        SelectTenant,
    },

    props: {
        canResetPassword: Boolean,
        status: String
    },

    data() {
        return {
            step: 1,
            tenants: [],
            selectedTenant: null,
            isMultipleTenants: false,
            form: this.$inertia.form({
                email: '',
                password: '',
                remember: false,
            })
        }
    },

    methods: {
        handleNextStep({ step, tenants = [], selectedTenant = null }) {
            this.step = step;
            if (tenants.length) this.tenants = tenants;
            if (selectedTenant) this.selectedTenant = selectedTenant;
        },

        isMultipleTenantshandle() {
            this.isMultipleTenants = true;
        },

        // checkEmail() {
        //         this.form.errors = {};
        //         axios.post(route('universal.find-tenants'), {
        //             email: this.form.email,
        //         }).then((response) => {
        //             console.log('response', response);
        //             if (response.data.status === "single_tenant") {
        //                 this.selectedTenant = response.data.tenant.id;
        //                 this.step = 2;
        //             } else if (response.data.status === "multiple_tenants") {
        //                 this.tenants = response.data.tenants;
        //                 this.selectedTenant = response.data.tenants[0].id;
        //                 this.isMultipleTenants = true;
        //                 this.step = 2;
        //             }
        //         }).catch(error => {
        //             if (error.response && error.response.data && error.response.data.message) {
        //                 console.log(error.response.data.message);
        //                 this.form.errors.email = [error.response.data.message][0];
        //             } else {
        //                 this.form.errors.email = ["Something went wrong, please try again later"];
        //             }
        //         });
        // },
        // authenticate() {
        //     this.form.errors = {};
        //     axios.post(route('universal.authenticate'), {
        //         email: this.form.email,
        //         password: this.form.password,
        //         remember: this.form.remember ? 'on' : ''
        //     }).then((response) => {
        //         if (response.data.status === "success") {
        //             this.step = 3;
        //         }else{
        //             this.form.reset('password');
        //         }
        //     }).catch(error => {
        //         if (error.response && error.response.data && error.response.data.message) {
        //             console.log(error.response.data.message);
        //             this.form.errors.password = [error.response.data.message][0];

        //         } else {
        //             this.form.errors.password = ["Something went wrong, please try again later"];
        //         }
        //         this.form.reset('password');
        //     });
        // },
        submit() {
            // console.log('tenant', this.selectedTenant);
            // console.log('Email', this.form.email);
            // axios.post(route('universal.tenant.redirect'), {
            //     email: this.form.email,
            //     password: this.form.password,
            //     tenant_id: this.selectedTenant
            // }).then((response) => {
            //     if (response.data.status === "success") {
            //         window.location.href = response.data.redirect_url || route('calendars');
            //     }
            // }).catch(error => {
            //     if (error.response && error.response.data && error.response.data.message) {
            //         console.log(error.response.data.message);
            //         this.form.errors.password = [error.response.data.message][0];
            //     } else {
            //         this.form.errors.password = ["Something went wrong, please try again later"];
            //     }
            // });

            // this.form
            // .transform(data => ({
            //     email: this.form.email,
            //     password: this.form.password,
            //     tenant_id: this.selectedTenant,
            // }))
            // .post(route('universal.tenant.redirect'), {
            //     // onSuccess: (response) => {
            //     //     // Handle successful response
            //     //     if (response.data.status === "success") {
            //     //         window.location.href = response.data.redirect_url || route('calendars');
            //     //     }
            //     // },
            //     onError: (error) => {
            //         // Handle error response
            //         if (error.response && error.response.data && error.response.data.message) {
            //             this.form.errors.password = [error.response.data.message][0];
            //         } else {
            //             this.form.errors.password = ["Something went wrong, please try again later"];
            //         }
            //     },
            // });


        }

    }
}
</script>

<style>
.validation_error_msg {
    font-weight: 400;
    margin: 6px 0 0 !important;
    color: red;
}
</style>
